var exports = {
  "uW": "GiftSection.module__section___TUhJMW",
  "xQ": "GiftSection.module__footerContainer___TUhJMW",
  "$P": "GiftSection.module__scrollPromptContainer___TUhJMW",
  "Zq": "GiftSection.module__scrollPromptText___TUhJMW",
  "$O": "GiftSection.module__scrollPromptIcon___TUhJMW",
};

module.exports = exports;
